module.exports = __webpack_public_path__ + "static/media/04.44fb281c.png";